// extracted by mini-css-extract-plugin
export default {"price":"a1-z","onSale":"b1-z","msrpLabelPrice":"c1-z","msrpLabel":"d1-z","originalPrice":"e1-z","percentOff":"f1-z"};